"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRecaptcha = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _actions = require("../user/actions");

var _reactRedux = require("react-redux");

var useRecaptcha = function useRecaptcha() {
  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      captchaToken = _useState2[0],
      setCaptchaToken = _useState2[1];

  var recaptchaRef = (0, _react.useRef)(null);
  var dispatch = (0, _reactRedux.useDispatch)();
  var handleRecaptcha = (0, _react.useCallback)(function (token) {
    setCaptchaToken(token || '');

    if (token) {
      dispatch((0, _actions.dispatchCaptchaSolved)());
    }
  }, [dispatch]);
  (0, _react.useEffect)(function () {
    var refreshCaptcha = function refreshCaptcha() {
      if (recaptchaRef.current && captchaToken) {
        recaptchaRef.current.reset();
        setCaptchaToken('');
      }
    };

    var tokenRefreshTimeout = null;

    if (captchaToken) {
      tokenRefreshTimeout = setTimeout(refreshCaptcha, 210000); // 210 seconds
    }

    return function () {
      if (tokenRefreshTimeout) {
        clearTimeout(tokenRefreshTimeout);
      }
    };
  }, [captchaToken, setCaptchaToken]);
  return {
    captchaToken: captchaToken,
    recaptchaRef: recaptchaRef,
    handleRecaptcha: handleRecaptcha
  };
};

exports.useRecaptcha = useRecaptcha;